import dayjs from "dayjs";
import { TFunction } from "i18next";
import { z } from "zod";

export const getInterventionFormSchema = (t: TFunction) => {
  return z.object({
    performedAt: z
      .string()
      .nullable()
      .optional()
      .refine(
        (val) => val == null || dayjs(val, "YYYY-MM-DD HH:mm:ss", true).isValid(),
        {
          message: t("captures.capture.intervention.errors.performed-at-invalid"),
        }
      ),
    performedBy: z.string().min(1, { message: t("captures.capture.intervention.errors.performed-by-required")}),
    notes: z.string().nullable().optional()
  });
};

export type InterventionForm = z.infer<ReturnType<typeof getInterventionFormSchema>>;